<template>
  <div class="breadcrumb-bar" :class="{ 'dark-mode': isDarkMode }">
    <div class="v-breadcrumbs embedded-breadcrumb-trail">
      <div class="home-img" v-if="showHome">
        <v-img
          src="../../../assets/Images/House.png"
          class="cursor-pointer"
          width="20"
          height="20"
          alt="Home"
          @click="onHomeClick"
        />
      </div>
      <template v-if="items.length">
        <div class="divider-img" v-if="showHome">
          <v-img
            src="../../../assets/Images/breadcrumb-right-con.png"
            width="6"
            height="11"
          />
        </div>
        <template v-for="(item, index) in items" :key="`crumb-${index}-${item.title}`">
          <div class="divider-img" v-if="index > 0">
            <v-img
              src="../../../assets/Images/breadcrumb-right-con.png"
              width="6"
              height="11"
            />
          </div>
          <div class="text-capitalize embedded-breadcrumb-item">
            <a
              v-if="item.pvtPath && !item.nonNav && homeMode === 'pvt'"
              href="#"
              @click.prevent="onPvtItemClick(item)"
            >
              {{ item.title }}
            </a>
            <router-link v-else-if="item.href && !item.nonNav" :to="item.href">
              {{ item.title }}
            </router-link>
            <span v-else>{{ item.title }}</span>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { navigateHome } from "@/utils/navHome";

export default {
  name: "EmbeddedBreadcrumbBar",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    homeMode: {
      type: String,
      default: "assets",
      validator: (v) => ["assets", "agentic", "pvt"].includes(v),
    },
    showHome: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
  },
  methods: {
    onHomeClick() {
      if (this.homeMode === "agentic") {
        this.$router.push({ name: "AgenticDashboard" });
        return;
      }
      if (this.homeMode === "pvt") {
        this.$emit("pvt-navigate", "/");
        return;
      }
      navigateHome(this.$router, this.$route);
    },
    onPvtItemClick(item) {
      if (item?.pvtPath) {
        this.$emit("pvt-navigate", item.pvtPath);
      }
    },
  },
};
</script>
